import React  from "react";

import  NeoLoader from "../components/neoLoader";
import StepManager from '../steps/stepManager';
import Style from '../components/style';

export default function Widget({ token, widgetKey, changeLanguage, onStep=()=>{}, onLeave=()=>{},  widget=null, lang=null, storage=null, step=null }) {
    if(!widget) {
        return <NeoLoader/>;
    }

    return (
        <React.Fragment>
            <Style style={widget.customs.css}/>
            <StepManager
                lang={lang}
                widgetKey={widgetKey}
                widget={widget}
                token={token}
                firstStep={step}
                onLeave={onLeave}
                onStep={onStep}
                storage={storage}
                changeLanguage={changeLanguage}
            />
        </React.Fragment>
    );
}
